<template>
  <div class="home_wrap">
    <!-- <van-nav-bar
      title="Convidar"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    /> -->

    <div class="top_wrap">
      <div class="title">
        {{ $t("促销信息") }}
      </div>
      <div class="link_box">
        <div class="qrcod_box">
          <div class="qrcode_img_box">
            <img
              :src="data.qrcode"
              alt=""
            >
          </div>
          <div
            class="btn primary"
            @click="downloadBase64Image"
          >
            {{ $t("点击保存") }}
          </div>
        </div>
        <div class="right_link_box">
          <div class="flex-between">
            <div class="textcolor1">
              {{ $t("我的链接") }}
            </div>
            <div class="rechargeColor">
              {{ $t("改变") }}
            </div>
          </div>
          <div class="link flex-between">
            <div class="textcolor1">
              {{ data.invite_url }}
            </div>
            <div
              class="rechargeColor"
              @click="doCopy(data.invite_url)"
            >
              <i class="el-icon-copy-document copy" />
            </div>
          </div>
          <div class="textcolor1">
            {{ $t("直接下属") }} &nbsp; <span>{{ data.direct_user_num }}</span>
          </div>
          <div class="textcolor1 code">
            {{ $t("邀请码") }} &nbsp;<span class="textcolorf">
              {{ data.invite_code }}</span>
            &nbsp;
            <i
              class="el-icon-copy-document rechargeColor"
              @click="doCopy(data.invite_code)"
            />
          </div>
        </div>
      </div>
      <div class="bottom_box">
        <div
          v-for="item in data.promotion"
          :key="item.title"
          class="link_item"
          @click="jumpUrl(item)"
        >
          <img
            :src="item.image"
            alt=""
          >
          <div class="title textcolor1">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="textcolor1 bottom_text">
        {{ $t("有效下属") }}
        <span class="rechargeColor">{{ data.valid_user_num }}</span>{{ $t("人们") }}
        <span
          class="rechargeColor"
          @click="$router.push('teamList')"
        >{{ $t("细节") }}</span>
      </div>
    </div>
    <div class="rule_box top_wrap textcolor1">
      <div>
        {{ $t("什么是有效的促销号码？（满足以下所有要求）") }}
      </div>
      <div class="rule_info">
        <div>
          {{ $t("下属累计存款") }}
          <span class="textcolorf">{{ data.valid_recharge }} {{ $t("或更多") }}</span>
        </div>
        <div>
          {{ $t("下级累积投注") }}
          <span class="textcolorf">{{ data.valid_bet }} {{ $t("或更多") }}</span>
        </div>
      </div>
    </div>
    <div
      v-show="isShowBox"
      class="bx_list"
    >
      <ul>
        <li
          v-for="(item, index) in boxList"
          :key="index"
          :class="getClass"
          @click="addBoxList(item.num, item.is_get, item.money, index)"
        >
          <div class="bx_tp">
            <img
              v-if="item.is_get == 0"
              class=""
              src="../../assets/images/betReward/1.png"
              alt=""
            >
            <img
              v-if="item.is_get == 1"
              src="../../assets/images/betReward/3.png"
              alt=""
              class="shadow_box"
            >
            <img
              v-if="item.is_get == 2"
              class=""
              src="../../assets/images/betReward/2.png"
              alt=""
            >
            <p>{{ item.condition }} {{ $t("人们") }}</p>
          </div>
          <div class="bx_txt">
            {{ item.money }}
          </div>
        </li>

        <div class="clear" />
      </ul>
    </div>
    <div
      v-show="!isShowBox"
      class="bx_top"
    >
      <div>
        {{ $t("tip1") }}
      </div>
    </div>
    <div class="bx_top">
      <div class="sm_tit">
        {{ $t("活动说明：") }}
      </div>
      <div class="sm_con">
        {{ $t("tip2") }}
      </div>
    </div>
    <div class="pop_box">
      <van-popup
        v-model="popShow"
        :get-container="popBox"
      >
        <div class="pop_title">
          {{ $t("邀请链接") }}
        </div>
        <div class="search_box flex-between">
          <el-select
            v-model="params.is_good"
            placeholder="请选择"
            popper-class="popper"
            class="select"
            :popper-append-to-body="false"
            @change="getPopList"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <van-search
            v-model="params.id"
            :placeholder="$t('输入会员ID')"
            @blur="getPopList"
          />
        </div>
        <div
          v-if="popList.length"
          class="list_box"
        >
          <div
            v-for="item in popList"
            :key="item.id"
            class="list_item"
          >
            <div class="item_top">
              <div class="code textcolorf">
                {{ item.id }}
                <i
                  class="el-icon-copy-document rechargeColor"
                  @click="doCopy(item.id)"
                />
              </div>
              <div class="textcolor1">
                {{ $t("是否有效") }}
                <span :class="`textcolorf ${item.is_good === 1 ? 'green' : 'red'}`">{{ item.is_good === 1 ? "Sim" :
                  "Não" }}</span>
              </div>
            </div>
            <div class="textcolor1">
              {{ $t("报名时间：") }} <span class="textcolorf">2024-08-04</span>
            </div>
          </div>
        </div>
        <empty v-else />
      </van-popup>
    </div>
    <!-- <ftNav /> -->
  </div>
</template>

<script>
import Vue from "vue";
import { NavBar, Search } from "vant";
import Fetch from "../../utils/fetch";
import ftNav from "../../components/footer_nav/footer_nav";
import empty from "../../components/empty.vue";
Vue.use(NavBar).use(Search);
export default {
  name: "Share",
  components: {
    ftNav,
    empty,
  },
  data() {
    return {
      info: {},
      boxList: [],
      isFetching: false,
      isShowBox: true,
      data: {},
      popShow: false,
      params: {
        is_good: "2",
      },
      options: [
        {
          value: "2",
          label: "Válido ou não",
        },
        {
          value: "1",
          label: "Eficiente",
        },
        {
          value: "0",
          label: "Inválido",
        },
      ],
      url: "/agent/allpidData",
      popList: [],
    };
  },
  computed: {
    getClass() {
      const len = this.boxList.length;
      let className = "";
      return className;
    },
  },
  created() { },
  mounted() {
    this.$bus.$emit("send2ftnav", 1);
    this.start();
  },
  methods: {
    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
        return 'IOS';
      } else if (userAgent.match(/Android/i)) {
        return 'Android';
      } else {
        return 'unknown';
      }
    },
    popBox() {
      document.querySelector(".pop_box");
    },
    searchBlur() { },
    changePop(v) {
      this.getPopList(v, this.url);
      this.popShow = true;
    },
    getPopList(v, url) {
      const params = {
        ...this.params,
        is_good: this.params.is_good === "2" ? undefined : this.params.is_good,
        id: this.params.id ? this.params.id : undefined,
      };
      if (v == 2) {
        this.url = "/agent/allppidData";
      }
      Fetch(this.url, params).then((res) => {
        this.popList = res.data.page;
      });
    },
    start() {
      // Fetch("/box/getLink").then((r) => {
      //   this.info = r.data;
      //   if (r.data.is_black == 1) {
      //     this.isShowBox = false;
      //   } else {
      //     this.isShowBox = true;
      //   }
      // });
      Fetch("/agent/init").then((res) => {
        this.data = res.data;
      });
      Fetch("/box/boxList").then((r) => {
        this.boxList = r.data.list;
      });
    },
    addBoxList(num, is_get, money, index) {
      if(this.data.is_receive_box === 1) return
      if (is_get != 1 || this.isFetching) return false;

      this.isFetching = true;

      Fetch("/box/receive", { num: num }).then((r) => {
        console.log(r);
        if (r.code == 1) {
          this.$message({
            title: "R$" + money,
            message: r.msg,
            type: "success",
          });
          this.boxList[index].is_get = 2;
        } else {
          this.$message({
            title: "R$" + money,
            message: r.msg,
            type: "error",
          });
        }

        this.isFetching = false;
      });
    },
    onClickLeft() {
      this.$router.push("/activity");
    },
    doCopy(val) {
      let _this = this;
      this.$copyText(String(val)).then(
        function (e) {
          _this.$toast({
            background: "#07c160",
            message: _this.$t("复制成功"),
          });
        },
        function (e) {
          // console.log(e);
        }
      );
    },
    jumpUrl(item) {
      window.location.href = this.getMobileOperatingSystem() === 'IOS' ? item.ios_url : item.android_url
    },
    downloadBase64Image() {
      const link = document.createElement('a');
      link.href = this.data.qrcode;
      link.download = 'Código2D.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.doCopy(this.data.invite_url)
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

.home_wrap {
  width: 100%;
  min-height: 80vh;
  // background-color: @third-color;
  padding-bottom: 1.8rem;
}

.baoxiang_bg {
  background-color: #2e2e2e;
}

.bx_top1 {
  width: 95%;
  margin: 0.2rem auto 0 auto;
  color: #fff;
  padding: 0.3rem;
  border-radius: 0.7rem;
  background-color: @secondary-color;
  font-size: 0.3rem;
  box-sizing: border-box;

  .top_txt {
    // width: 24%;
    // float: left;
    line-height: 0.42rem;
    background: linear-gradient(to right,
        @gradientColorStar,
        @gradientColorEnd );
    border-radius: 0.3rem;
    padding: 0.1rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
  }
}

.bx_teamList {
  width: 95%;
  margin: 0.2rem auto 0 auto;
  color: #fff;
  padding: 0.1rem;
  border-radius: 0.7rem;
  background-color: @secondary-color;
  font-size: 0.3rem;
  box-sizing: border-box;
  padding-left: 0.5rem;
}

.bx_top2 {
  width: 95%;
  margin: 0.2rem auto 0 auto;
  color: #fff;
  padding: 0.3rem;
  border-radius: 0.3rem;
  background: linear-gradient(to right, @gradientColorStar, @gradientColorEnd);
  font-size: 0.3rem;
  box-sizing: border-box;
}

.bx_top {
  width: 95%;
  margin: 0.2rem auto 0 auto;
  color: #fff;
  padding: 0.3rem;
  border-radius: 0.3rem;
  background-color: @secondary-color;
  font-size: 0.3rem;
  box-sizing: border-box;

  .top_txt {
    // width: 24%;
    // float: left;
    line-height: 0.42rem;
    background: linear-gradient(to right, @secondary-color, @primary-color);
    border-radius: 0.3rem;
    padding: 0.1rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
  }
}

.box_link {
  display: flex !important;
}

.bx_link {
  // width: 70%;
  height: 0.62rem;
  // border: 1px solid #e5e5e5;
  border-radius: 0.1rem;
  line-height: 0.62rem;
  height: 0.62rem;
  color: #f5f5f5;
  // float: left;
  font-size: 0.24rem;
  padding: 0 2%;
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    color: #fff !important;
    font-size: 0.3rem;
  }

  img {
    // float: right;
    width: 0.35rem;
    margin-bottom: 0.08rem;
  }
}

.bx_lianxi {
  margin-top: 0.3rem;
  padding: 0.3rem 0 0.2rem 0;
  line-height: 0.36rem;
  border-bottom: 1px solid #e5e5e5;
  border-top: 1px solid #e5e5e5;
}

.lx_con {
  margin: 0.2rem 0;
}

.lx_con ul {
  width: 50%;
  float: left;

  li {
    width: 30%;
    float: left;
    text-align: center;
    font-size: 0.24rem;
    color: #f5f5f5;

    img {
      width: 0.85rem;
    }
  }
}

.lx_con a {
  color: #f5f5f5;
}

.lx_txt {
  width: 16%;
  float: right;
  color: #f8b600;

  img {
    width: 0.13rem;
    margin: 0.5rem 0 0 0.2rem;
  }
}

.img_title {
  flex: 1;
  margin-top: 0.2rem;
}

.logo_img {
  flex: 0.4;

  img {
    width: 100%;
  }
}

.bx_two {
  // margin-top: 0.2rem;
  font-size: 0.28rem;
  display: flex;
  align-items: center;

  b {
    color: #f8b600;
    margin: 0 0.1rem;
  }

  a {
    display: inline-block;
    height: 0.8rem;
    line-height: 0.8rem;
    // background: @anttextcolor;
    // color:@primary-color;
    color: rgb(246, 178, 10);
    font-weight: 700;
    margin-left: 0.1rem;
    padding: 0 0.1rem;
    border-radius: 0.2rem;
  }
}

.txt_tit {
  text-align: center;
  line-height: 0.36rem;
  font-size: 0.28rem;
  display: flex;
}

.txt_01 {
  width: 95%;
  margin: 0.2rem auto 0 auto;
  color: #fff;
  padding: 0.3rem;
  border-radius: 0.3rem;
  background-color: @secondary-color;
  font-size: 0.3rem;
  box-sizing: border-box;
  display: flex;
}

.txt_left {
  // width: 50%;
  // float: left;
  color: @textcolor1;
}

.txt_right {
  flex: 1;
  color: #fff;
  text-align: end;
}

.txt_02 {
  width: 95%;
  margin: 0.2rem auto 0 auto;
  color: #fff;
  padding: 0.3rem;
  border-radius: 0.3rem;
  background-color: @secondary-color;
  font-size: 0.3rem;
  box-sizing: border-box;
  display: flex;
}

.bx_list {
  width: 95%;
  margin: 0 auto 0 auto;
  color: #fff;
  padding: 0.2rem 0.3rem 0.3rem 0.3rem;
  border-radius: 0.2rem;
  background-color: @secondary-color;
  font-size: 0.3rem;
  box-sizing: border-box;
  margin-top: 0.2rem;
}

.shadow_box {
  background: transparent;
  box-shadow: #765400 0px 0.3rem 0.5rem 0.1rem;
}

.bx_list li {
  width: 25%;
  float: left;
  text-align: center;
  padding-bottom: 0.6rem;
  position: relative;

  // &:after,
  // &:before {
  //   position: absolute;
  //   top: 26%;
  //   content: "";
  //   width: .2rem;
  //   height: .2rem;
  //   border-bottom: 3px solid @textcolor1;
  //   border-left: 3px solid @textcolor1;
  //   transform: rotate(-135deg);
  //   border-radius: 3px;
  // }
  // &::after {
  //   right: 0;
  // }
  // &::before {
  //   right: -6px;
  // }
  // &:nth-child(4n) {
  //   &:after,
  //   &:before {
  //     left: 50%;
  //     margin-left: -.1rem;
  //     transform: rotate(-45deg);
  //   }
  //   &::after {
  //     top: calc(84% - 6px);
  //   }
  //   &::before {
  //     top: 84%;
  //   }
  // }
  .bx_tp img {
    width: 1.7rem;
    left: 10%;
  }

  .bx_tp p {
    margin-top: -0.48rem;
    color: #fff;
    font-size: 0.28rem;
  }

  .bx_txt {
    font-size: 0.28rem;
  }
}

.sm_tit {
  color: #fff;
  font-size: 。46rem;
  font-weight: bold;
}

.sm_con {
  color: #f5f5f5;
  font-size: 0.32rem;
  line-height: 0.52rem;
  margin-top: 0.2rem;
}

.clear {
  clear: both;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.rechargeColor {
  color: @rechargeColor;
}

.textcolor1 {
  color: @textcolorf;

  span {
    color: @textcolor1;
  }
}

.textcolorf {
  color: @textcolorf;
}

.top_wrap {
  width: 95%;
  padding: 10px;
  background-color: @secondary-color;
  box-sizing: border-box;
  margin: 10px auto;
  border-radius: 6px;

  &>.title {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    margin-bottom: 10px;
    color: @textcolorf;
    border-bottom: 1px solid @bodercolor;
  }

  .link_box {
    display: flex;

    .right_link_box {
      flex: 1;
      margin-left: 10px;
    }

    .qrcod_box {
      width: 68px;
      box-sizing: border-box;

      .qrcode_img_box {
        width: 100%;
        height: 68px;
        border: 1px solid @bodercolor2;
        padding: 2px;
        border-radius: 4px 4px 0 0;
      }

      img {
        width: 100%;
        height: 100%;
        border-radius: 4px 4px 0 0;
        display: block;
      }

      .btn {
        width: 100%;
        font-size: 12px;
        text-align: center;
        padding: 2px;
        border-radius: 0 0 4px 4px;

        &.primary {
          background-color: @rechargeColor;
          color: @textcolor6;
        }
      }
    }
  }

  .link {
    margin-top: 0.2rem;
    margin-bottom: 0.32rem;
    padding: 0.2rem 0.3rem;
    border-radius: 0.2rem;
    border: 1px solid @bodercolor;
  }

  .code {
    margin-top: 6px;
  }
}

.bottom_box {
  display: flex;
  align-items: center;
  padding: 0.24rem 0.24rem 20px;
  overflow-x: auto;
  margin-top: 10px;

  &::-webkit-scrollbar {
    height: 4px;
    border-radius: 4px;
    background-color: @activityColor;
  }

  &::-webkit-scrollbar-thumb {
    background-color: @third-color;
    height: 4px;
    border-radius: 5px;
  }

  .link_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 0.3rem;
    font-size: 0.3rem;

    img {
      width: 1rem;
      height: 1rem;
      margin-bottom: 0.12rem;
      border-radius: 50%;
    }

    .imgbox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.94rem;
      height: 0.94rem;
      border-radius: 50%;
      font-size: 0.6rem;
      color: @rechargeColor;
      margin-bottom: 0.12rem;
      border: 1px solid @bodercolor;
    }
  }
}

.bottom_text {
  padding: 12px 0 4px;
  font-size: 11px;

  span {
    padding: 0 4px;
  }
}

.rule_box {
  font-size: 12px;
  text-align: center;

  .rule_info {
    margin-top: 6px;

    div {
      height: 35px;
      line-height: 35px;

      &:first-child {
        background-color: @activityColor;
        border-radius: 6px;
      }
    }
  }
}

.pop_box {
  .search_box {
    padding: 0 12px 12px;

    .select {
      width: 50%;

      :deep(.el-input__inner) {
        height: 32px;
        border-radius: 32px;
        background-color: @secondary-color;
        border: 1px solid @bodercolor;
        color: @textcolorf;
      }

      :deep(.el-input__icon) {
        line-height: 32px;
      }
    }
  }

  :deep(.van-popup) {
    width: 85%;
    background-color: @secondary-color;
    border-radius: 12px;
  }

  .pop_title {
    color: @textcolorf;
    font-size: 16px;
    padding: 12px;
    text-align: center;
  }

  :deep(.van-search) {
    width: 45%;
    padding: 0;
    height: 32px;
    border-radius: 28px;
    background-color: @secondary-color;
    margin-left: 10px;

    .van-search__content {
      border-radius: 28px;
      height: 32px;
      border: 1px solid @bodercolor;
      background-color: @secondary-color;
    }

    .van-icon {
      color: @textcolorf;
      line-height: 32px;
    }

    .van-cell {
      padding: 0 8px 0 0;

      input {
        font-size: 14px;
        color: @textcolorf;
        line-height: 32px;

        &::placeholder {
          font-size: 12px;
        }
      }
    }
  }

  .list_box {
    height: 60vh;
    overflow-y: auto;
    padding: 0 16px 20px;

    .list_item {
      padding: 16px 10px;
      font-size: 10px;

      &:nth-child(2n) {
        background-color: @activityColor;
        border-radius: 6px;
      }

      .item_top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;

        .green {
          color: @vipBacColor;
        }

        .red {
          color: @jiaoColor;
        }
      }
    }
  }
}
</style>

<style lang="less">
@import "../../assets/css/variables.less";

.popper {
  z-index: 2204 !important;
  background-color: @activityColor;
  border: none;
  position: absolute !important;
  left: 0 !important;
  top: 100% !important;

  .el-select-dropdown__item span {
    color: @textcolorf;
  }

  .selected {
    background-color: @third-color;
  }

  .popper__arrow,
  .popper__arrow::after {
    border-bottom-color: @activityColor !important;
  }
}
</style>